<div id="panel">
  <div id="icon">
    <mat-icon color="primary">drive_folder_upload</mat-icon>
  </div>
  <div id="details">
    <div id="current-info">
      <div id="current-file">{{ collection.currentFile?.name }}</div>
      <div id="progress-info" *ngIf="collection.uploadFiles">{{ collection.uploadFiles.length - collection.queueFiles.length }}/{{ collection.uploadFiles.length }}</div>
    </div>
    <div id="current-file-progress-bar">
      <mat-progress-bar mode="determinate" [value]="currFileProgress"></mat-progress-bar>
    </div>
    <div id="overall-file-progress-bar">
      <mat-progress-bar mode="determinate" [value]="((collection.uploadFiles.length - collection.queueFiles.length) / collection.uploadFiles.length) * 100"></mat-progress-bar>
    </div>
  </div>
  <div id="actions">
    <button
      mat-icon-button
      *ngIf="collection.state === STATE.DONE || collection.state === STATE.PAUSED || collection.state === STATE.ERROR"
      [matTooltip]="'Remove the element from the list' | translate"
      (click)="delete()"
    >
      <mat-icon>delete</mat-icon>
    </button>
    <button mat-icon-button *ngIf="collection.state === STATE.DONE">
      <mat-icon>check</mat-icon>
    </button>
    <button mat-icon-button *ngIf="collection.state === STATE.RUNNING || collection.state === STATE.RETRY" [matTooltip]="'Pause the operation' | translate" (click)="pause()">
      <mat-icon>pause</mat-icon>
    </button>
    <button mat-icon-button *ngIf="collection.state === STATE.PAUSED" [matTooltip]="'Resume the operation' | translate" (click)="resume()">
      <mat-icon>play_arrow</mat-icon>
    </button>
  </div>
</div>
<div id="warnings" [ngClass]="{ 'expand-warning-box': expandWarningBox }" (click)="expandWarningBox = !expandWarningBox">
  <div *ngFor="let err of collection.errors">
    <mat-icon color="warn">warning</mat-icon>
    <span>
      {{ err.msg }}
    </span>
  </div>
</div>
